import { render, staticRenderFns } from "./cModalMezclas.vue?vue&type=template&id=4b14b5a4"
import script from "./cModalMezclas.vue?vue&type=script&lang=js"
export * from "./cModalMezclas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports